import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'

import { chainDecorators, memoized } from '../../utils/ReactUtils'


const decorators = [
  memoized,
]

function Seo(props) {
  const { title, keywords, description, image } = props

  return (
    <Helmet
      titleTemplate="Big Boss | %s"
      title={title}
    >
      <meta
        name="keywords"
        content={keywords}
      />
      <meta
        name="description"
        content={description}
      />
      <meta
        property="og:image"
        content={image}
      />
      <meta
        property="og:title"
        content={title}
      />
      <meta
        property="og:description"
        content={description}
      />
    </Helmet>
  )
}

Seo.propTypes = {
  title: PropTypes.string,
  keywords: PropTypes.string,
  image: PropTypes.string,
  description: PropTypes.string,
}

Seo.defaultProps = {
  title: '',
  keywords: '',
  image: '',
  description: '',
}

Seo = chainDecorators(decorators, Seo)

export default Seo
